import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input, Input, OnDestroy, OnInit } from "@angular/core";
import { WebhookFormInputComponent } from "../webhook-form-input/webhook-form-input.component";
import { WebhookCommonComponent } from "../common.components";

@Component({
    selector: 'webhook-form-textbox',
    templateUrl: './webhook-form-textbox.component.html',
    styleUrl: './webhook-form-textbox.component.scss',
    standalone: false
})

export class WebhookFormTextBoxComponent extends WebhookCommonComponent implements OnInit, OnDestroy {
   
  
}